import {takeLatest} from 'redux-saga/effects'
import { fetchBanners } from 'redux/slices/bannerSlices';
import { toggleBannerStatus } from 'redux/slices/bannerSlices';
import { tryCreateBanner } from 'redux/slices/bannerSlices';
import { tryUpdateBanner } from 'redux/slices/bannerSlices';
import { tryUpdateBannerType } from 'redux/slices/bannerSlices';
import { tryGetActiveFlashSale } from 'redux/slices/bannerSlices';
import { tryDeleteBannerType } from 'redux/slices/bannerSlices';
import { tryCreateBannerType } from 'redux/slices/bannerSlices';
import { rearrangeBanners } from 'redux/slices/bannerSlices';
import { removeBanner } from 'redux/slices/bannerSlices';
import { fetchPages } from 'redux/slices/bannerSlices';
import { handleCreateBanner, handleCreateBannerPage, handleDeleteBannerType, handleFetchBannerPage, handleFetchBanners, handleGetActiveFlashSale, handleRearrangeBanner, handleRemoveBanner, handleToggleBannerStatus, handleUpdateBanner, handleUpdateBannerType } from '../handlers/bannerHandler';


const bannerSaga = [
  takeLatest(fetchPages.type, handleFetchBannerPage),
  takeLatest(fetchBanners.type, handleFetchBanners),
  takeLatest(removeBanner.type, handleRemoveBanner),
  takeLatest(rearrangeBanners.type, handleRearrangeBanner),
  takeLatest(toggleBannerStatus.type, handleToggleBannerStatus),
  takeLatest(tryCreateBannerType.type, handleCreateBannerPage),
  takeLatest(tryCreateBanner.type, handleCreateBanner),
  takeLatest(tryDeleteBannerType.type, handleDeleteBannerType),
  takeLatest(tryUpdateBanner.type, handleUpdateBanner),
  takeLatest(tryGetActiveFlashSale.type, handleGetActiveFlashSale),
  takeLatest(tryUpdateBannerType.type, handleUpdateBannerType),
]

export default bannerSaga;
